import { RoofSlabSection } from "@/commons/interface/building/roof-slab-section"
import classNames from "classnames";
import { ReactComponent as DirectionDrawSvg } from '../icons/direct-draw.svg'
import { graphicStore } from "@/commons/store/graphic-store";
import { ARCHI_CTRL_TYPE } from "@/passets/archibase-engine/enums/archibase-control-type";
import { ARCHIBASE_SINGAL } from "@/passets/archibase-engine/enums/archibase-singal";
import { PlineT } from "pytha";
import { useParams } from "react-router";
import TnMessage from "@/commons/widget/message";

interface Iprops {
    item: RoofSlabSection
    selected: boolean // 是否处于选中状态
}


// 屋面板侧边栏-屋面板条目（展示态）
export default function RoofSlabDisplayItem(props: Iprops) {
    const { item } = props;

    const { projectUuid, modelUuid } = useParams()

    // 直接布置
    const onAssemble = () => {
        if (!item.entity) {
            TnMessage.warning("缺少屋面板截面，请先绘制");
            return;
        }
        let section = new PlineT().fromJson(item.entity)
        // 激活布置屋面板的二级控制器
        if (!graphicStore.extraContext.getCurrentViewEditor().cmdControl.currentControl || graphicStore.extraContext.getCurrentViewEditor().cmdControl.currentControl.id !== ARCHI_CTRL_TYPE.ASSEMBLE_ROOF_SLAP) {
            graphicStore.extraContext.getCurrentViewEditor().cmdControl.activateSubCommandControl("ASSEMBLEROOFSLAP");
            graphicStore.extraContext.listeners.getSignal(ARCHIBASE_SINGAL.onAssembleRoofSlapByPoint).dispatch(section, projectUuid, modelUuid);
        }
    }

    return (
        <div className="roof-slab-item">
            <div className={classNames({
                "name": true,
                "selected": props.selected,
            })}>
                <div className="text ellipsis">{item.name}</div>
                <DirectionDrawSvg className="icon" onClick={onAssemble} />
            </div>
            {/* <div className="legeng">
                图例
            </div> */}
        </div>
    )
}